import { useNavigate } from 'react-router-dom';

import { getPath } from '@services/RouteService/paths';

import { REACT_APP_APP_DOMAIN } from '@shared/constants';

export const useBackToEntitySelection = () => {
    const navigate = useNavigate();
    const onBackToEntity = (companySlug: string) => {
        if (companySlug !== 'portal') {
            return location.replace(
                `${window.location.protocol}//${REACT_APP_APP_DOMAIN}${getPath({
                    path: '/auth/welcome',
                })}`,
            );
        }
        return navigate(getPath({ path: '/auth/welcome' }));
    };

    return {
        onBackToEntity,
    };
};
